import { Button, Grid, Stack, Typography } from '@mui/material';
import {
  COST_SUMMARY_KINDS_OPTIONS,
  COST_SUMMARY_TYPES_OPTIONS,
} from 'pages/admin/CostDashboard/constants';
import { getIntervalFromDateRange } from 'pages/admin/CostDashboard/helper';
import { FormProvider, useForm } from 'react-hook-form';
import { FormSelectField, FormTextFieldBase } from 'shared/components/form';
import { CostSummaryV2Request } from 'shared/types/protoc-gen/bffbillsystem';

import { IUseGetCostSummary } from './hooks/useGetCostSummary';

interface ICostSummaryFilter extends IUseGetCostSummary {
  setCostFilterProps: React.Dispatch<React.SetStateAction<IUseGetCostSummary>>;
}

const CostSummaryFilter: React.FC<ICostSummaryFilter> = ({
  area,
  endDate,
  kind,
  setCostFilterProps,
  startDate,
  type,
}) => {
  const form = useForm<CostSummaryV2Request>({
    defaultValues: {
      period: getIntervalFromDateRange(startDate, endDate),
      startDate,
      endDate,
      kind,
      type,
      area,
    },
  });

  const handleApply = () => {
    const values = form.getValues();

    setCostFilterProps({
      startDate: values.startDate,
      endDate: values.endDate,
      kind: values.kind,
      type: values.type,
      area: values.area,
    });
  };

  return (
    <FormProvider {...form}>
      <form>
        <Stack spacing={3}>
          <Typography variant="h5">Filter & Analyze Cost</Typography>

          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack>
                <Typography>Start Date</Typography>
                <FormTextFieldBase
                  fieldConfig={{
                    name: 'startDate',
                    label: 'Start Date',
                  }}
                  type="date"
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack>
                <Typography>End Date</Typography>
                <FormTextFieldBase
                  fieldConfig={{
                    name: 'endDate',
                    label: 'End Date',
                  }}
                  type="date"
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack>
                <Typography>Kind</Typography>

                <FormSelectField
                  fieldConfig={{ name: 'kind' }}
                  items={COST_SUMMARY_KINDS_OPTIONS}
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack>
                <Typography>Type</Typography>

                <FormSelectField
                  fieldConfig={{ name: 'type' }}
                  items={COST_SUMMARY_TYPES_OPTIONS}
                />
              </Stack>
            </Grid>

            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                p: 2,
              }}
              xs={8}
            >
              <Button onClick={handleApply}>Apply</Button>
            </Grid>
          </Grid>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default CostSummaryFilter;
